import {StylesConfig} from 'react-select';

import {useTheme} from '@mui/material';

export const modulesSwitchSelectStylesConfig = () => {
  const bgColor = '#060511';
  const menuBgColor = '#100f22';

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const theme = useTheme();

  const dropdownStyles: StylesConfig = {
    container: (styles) => ({
      ...styles,
      width: '100%',
      userSelect: 'none',
    }),

    control: (styles) => ({
      ...styles,
      backgroundColor: bgColor,
      border: 0,
      minHeight: '40px',
      boxShadow: '0px 0px 0px 0px',
      fontWeight: 'bold',
    }),

    option: (styles, {isFocused, isSelected}) => ({
      ...styles,
      color: 'white',
      backgroundColor: isFocused ? theme.palette.primary.main : isSelected ? theme.palette.primary.dark : menuBgColor,
    }),

    input: (styles) => ({
      ...styles,
      color: 'white',
      textAlign: 'left',
    }),

    placeholder: (styles) => ({
      ...styles,
      color: 'white',
      textAlign: 'left',
    }),

    singleValue: (styles) => ({
      ...styles,
      color: 'white',
      textAlign: 'left',
    }),
    menu: (styles) => ({
      ...styles,
      marginTop: 0,
      zIndex: 9999,
    }),
    menuList: (styles) => ({
      ...styles,
      backgroundColor: menuBgColor,
      textAlign: 'left',
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: theme.palette.selectBox.option.selectedBackgroundColor,
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: 'white',
    }),
    multiValueRemove: (styles) => ({
      ...styles,

      ':hover': {
        backgroundColor: '#602E2E',
        color: '#DB6E78',
      },
    }),
  };

  return dropdownStyles;
};
